<template>
  <div>
    <HeadNav selectedLanguage="en" page="blog1" :gotodownload="gotodownload" :apk="apk" />
<div id="page" class="site grid-container container hfeed">
      <div id="content" class="site-content">
        <div id="primary" class="content-area">
          <main id="maincontent" class="site-main">
            <section id="section-1" class="section-content">
              <h1 class="section-1-blog-head">
                What is GB WhatsApp? Learn How to Use It Safely in 2025
              </h1>

              <div class="lazy-picture-container writer-banner width-75" style="text-align: center;">
                <picture><img width="auto" height="auto" alt="what is GB WhatsApp"
                    src="../assets/what-is-GB-WhatsApp.webp">
                </picture>
              </div>
              <!-- <div class="is-vertical is-content-justification-center is-layout-flex wp-container-9 wp-block-buttons">
              <div class="wp-block-button">
                <a id="dl" class="wp-block-button__link wp-element-button" target="_blank" rel="dl noopener" @click="gotodownload()">Download GB WhatsApp</a>
              </div>
            </div> -->
              <p class="writter-content">
                <a href="https://gbmodshub.com/" class="jump-url">GB WhatsApp</a> is a modified (or "modded") version
                of the official WhatsApp Messenger developed by
                third-party developers. It offers additional features that are not available in the original WhatsApp,
                such as more privacy controls, customization, and extended media sharing limits.
              </p>

              <h2 class="intro-title blog">
                GB WhatsApp Screen (Interface)
              </h2>
              <p class="writter-content">
                The interface looks very similar to the official WhatsApp, but includes:
              <ul>
                <li> Custom themes</li>
                <li> Hidden chats</li>
                <li> Extra privacy options</li>
                <li> Additional icons and layouts</li>
              </ul>
              <!--  -->
              <div class="lazy-picture-container writer-banner width-75" style="text-align: center;">
                <picture><img width="auto" height="auto" alt="what is GB WhatsApp" src="../assets/gb-seething.webp">
                </picture>
              </div>
              </p>
              <!--  -->

              <h2 class="intro-title blog">
                Functions of GB WhatsApp
              </h2>
              <p class="writter-content">
                Here are some popular features:
              </p>
              <figure class="wp-block-table is-style-regular">
                <table class="has-fixed-layout">
                  <tbody>
                    <tr>
                      <th>Feature</th>
                      <th>Description</th>
                    </tr>
                    <tr>
                      <th>Themes and Interface Customization</th>
                      <td>
                        Offers a wide range of themes and interface customization options, allowing users to change
                        colors, fonts, layouts, or even create custom themes.
                      </td>
                    </tr>
                    <tr>
                      <th>Privacy Features</th>
                      <td>
                        Hide blue ticks, double ticks, typing status, recording status, and freeze "Last Seen" for extra
                        privacy protection.
                      </td>
                    </tr>
                    <tr>
                      <th>Anti-Delete Messages and Status</th>
                      <td>
                        Prevent others from deleting their sent messages and statuses; users can view deleted content.
                      </td>
                    </tr>
                    <tr>
                      <th>Large File Transfer</th>
                      <td>Send video and image files up to 50MB, much larger than the official WhatsApp limit of 16MB.
                      </td>
                    </tr>
                    <tr>
                      <th>Send Multiple Images</th>
                      <td>Allows sending up to 90 images at once, far more than the official WhatsApp limit of 10
                        images.</td>
                    </tr>
                    <tr>
                      <th>Dual WhatsApp Account Support</th>
                      <td>Run two separate WhatsApp accounts on one device, ideal for keeping work and personal accounts
                        separate.</td>
                    </tr>
                    <tr>
                      <th>Custom Notifications and Alerts</th>
                      <td>
                        Set personalized notification tones, vibrations, and background colors for each contact to
                        differentiate message sources.
                      </td>
                    </tr>
                    <tr>
                      <th>App Lock Feature</th>
                      <td>Lock the WhatsApp app with a PIN code or fingerprint to protect privacy and prevent
                        unauthorized access.</td>
                    </tr>
                    <tr>
                      <th>Emojis and Stickers</th>
                      <td>Provides a larger selection of emojis and stickers, with support for custom sticker packs to
                        make chats more expressive.</td>
                    </tr>
                    <tr>
                      <th>Disappearing Messages</th>
                      <td>Enable the self-destruct feature for messages that automatically delete after being read,
                        similar to WhatsApp's "View Once" feature.</td>
                    </tr>
                    <tr>
                      <th>Enhanced Multimedia</th>
                      <td>Send high-quality images and videos without compression, ensuring that multimedia files
                        maintain the best possible quality.</td>
                    </tr>
                  </tbody>
                </table>
              </figure>

              <h2 class="intro-title blog">Versions of GB WhatsApp</h2>
              <p class="writter-content">
                Since GB WhatsApp is unofficial, it's updated by different developers. Versions change often, but some
                well-known ones include:
              <ul>
                <li> GB WhatsApp by AlexMods</li>
                <li> GB WhatsApp by HeyMods</li>
                <li> GB WhatsApp by FouadMods</li>
              </ul>
              Each developer adds unique tweaks, so features may vary slightly.
              </p>
              <h2 class="intro-title blog">
                Comparison: GB WhatsApp vs WhatsApp
              </h2>
              <figure class="wp-block-table is-style-regular">
                <table class="has-fixed-layout">
                  <tbody>
                    <tr>
                      <th>Feature</th>
                      <th>GB WhatsApp</th>
                      <th>WhatsApp (Official)</th>
                    </tr>
                    <tr>
                      <td>Developer</td>
                      <td>
                        Independent developers
                      </td>
                      <td>Meta (Facebook)</td>
                    </tr>
                    <tr>
                      <td>Custom Themes</td>
                      <td>
                        �?Yes
                      </td>
                      <td>�?No</td>
                    </tr>
                    <tr>
                      <td>Privacy Controls</td>
                      <td>
                        �?More options
                      </td>
                      <td>�?Basic controls</td>
                    </tr>
                    <tr>
                      <td>Multi-account support</td>
                      <td>
                        �?Yes
                      </td>
                      <td>
                        �?No
                      </td>
                    </tr>
                    <tr>
                      <td>Read deleted messages</td>
                      <td>�?Yes</td>
                      <td>
                        �?No
                      </td>
                    </tr>
                    <tr>
                      <td>File size limit</td>
                      <td>Up to 700MB</td>
                      <td>16MB (media), 100MB (docs)</td>
                    </tr>
                    <tr>
                      <td>Auto-reply</td>
                      <td>
                        �?Yes
                      </td>
                      <td>
                        �?No (except WhatsApp Business)
                      </td>

                    </tr>
                    <tr>
                      <td>
                        Security & Privacy
                      </td>
                      <td>�?Risky</td>
                      <td>�?Strong encryption</td>
                    </tr>
                    <tr>
                      <td>Available on App Stores</td>
                      <td>�?No</td>
                      <td>�?Yes</td>
                    </tr>
                  </tbody>
                </table>
              </figure>
              <h2 class="intro-title blog">
                What mobile system is GB WhatsApp used for?
              </h2>
              <p class="writter-content">
                GB WhatsApp is <strong>only available for Android</strong> phones. <br>
                It is <strong>not available</strong> on iOS (iPhones), and any iOS versions found online are usually
                fake or unsafe.
              </p>
              <h2 class="intro-title blog">Is GB WhatsApp Safe to Use?</h2>
              <p class="writter-content">
                Since GB WhatsApp is not an official app, there’s a risk of being banned by WhatsApp if they detect that
                you're using a modded version. While some users report using it without issues, others have been
                temporarily or permanently banned from WhatsApp after using GB WhatsApp for a while. <br>
                If you're determined to use GB WhatsApp despite the risks, here are a few tips for using it as safely as
                possible:
              <ol>

                <li> <strong>Backup Your Data:</strong> Make sure to back up your chats regularly, either through
                  WhatsApp’s cloud backup
                  or an external backup option. This way, if you’re banned or face issues, you won’t lose your data.
                </li>
                <li> Use Dual WhatsApp: Consider using GB WhatsApp alongside the official WhatsApp app (using different
                  numbers) to avoid using just one app for all your communication, minimizing the risk of a permanent
                  ban. </li>
                <li> <strong>Update Regularly:</strong> Since modded apps often get patched by developers for new
                  security fixes, make
                  sure you update GB WhatsApp frequently to the latest version. </li>
                <li> <strong>Avoid Sharing Sensitive Data:</strong> Be careful about sharing highly sensitive personal
                  or financial
                  information through modded apps, as these may not have the same level of encryption or security as the
                  official WhatsApp. </li>
                <li> <strong>Download from Trusted Sources:</strong> Always download from trusted mod developers and
                  reputable websites
                  to avoid malware or fake versions. </li>

              </ol>
              </p>
              <h2 class="intro-title blog">FAQ About GB WhatsApp</h2>
              <h3>Can I use GB WhatsApp alongside official WhatsApp?</h3>
              <p>
                Yes, you can run GB WhatsApp alongside the official WhatsApp app on the same device using a different
                phone number.
              </p>
              <h3>Will I lose my chats if I switch to GB WhatsApp?</h3>
              <p>
                If you properly back up your chats on the official WhatsApp and restore them during GB WhatsApp setup,
                you can keep your chat history intact.
              </p>
              <h3>
                Are there alternatives to GB WhatsApp?
              </h3>
              <p>
                Yes, other WhatsApp mods like FM WhatsApp, WhatsApp Plus, and YoWhatsApp offer similar features.
                However, all come with similar risks and are unofficial.
              </p>
              <h3>
                Can I use GB WhatsApp on iPhone or only on Android?
              </h3>
              <p>
                GB WhatsApp is currently available only for Android devices because it requires APK installation, which
                is not supported on iOS. iPhone users cannot install GB WhatsApp unless their device is jailbroken,
                which is risky and not recommended due to security and warranty concerns. <br>
                If you’re an iPhone user, stick to the official WhatsApp app for the safest experience.
              </p>
              <Carousel />
            </section>

          </main>
        </div>
      </div>
    </div>

    <div v-if="$global.isMobileDevice()" id="fixed-bottom-btn" class="fix-bottom-btn" @click="gotodownload()">
      Download GBWhatsapp APK
    </div>
  </div>
</template>

<script>
import '@/css/base.scss';
import HeadNav from '@/components/HeadNav.vue';
import Carousel from '@/components/Carousel.vue';
import doc from '@/documents/blogs.js';
export default {
  name: 'Home',
  components: {
    HeadNav,
    Carousel,
  },
  data() {
    return {
      pageName: 'home',
      selectedLanguage: 'en',
      doc: doc,
      showapk: false,
      apk: null,
      from: 'gb',
      filename: 'gb',
      relatedPosts: [
        {
          image: require('@/assets/uninstall-gbwhatsapp.webp'),
          title: 'Related Post Title 1',
          description: 'Brief description of the related post. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
        },
        {
          image: require('@/assets/uninstall-gbwhatsapp.webp'),
          title: 'Related Post Title 2',
          description: 'Brief description of the related post. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
        }
      ]
    };
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    console.log(this.$global.GetQueryString('from'));
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {

    downloadfrom(reason) {
      this.download();
      this.$logEvent(`download_from_${reason}`, 'download');
      // window.location.href = `https://gbapp.pro?apps=gb&domain=gbwhatsapp.chat&appName=GB_gbwhatsapp.chat`;
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
            console.log('apk getted');
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    gotodownload() {
      console.log(this.apk);
      // this.showapk = true
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
    jump(url) {
      window.location.href = url;
    },
    goto(page) {
      this.$router.push({
        name: `${this.selectedLanguage}-${page}`
      });
    }
  },
};
</script>
<style lang="scss" scoped>
$--group-option-flex: 0 calc(1 / 5) * 100% !default;

.blog1-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  /* 小屏幕左右边�?*/
}

.main-content {
  flex: 2;
  margin-right: 30px;
  background: #f7f7f7;
  padding: 20px;
  border-radius: 10px;
}

.related-posts {
  flex: 1;
  /* �?/3宽度 */
}

.blog1-container {
  display: flex;
  gap: 30px;
  /* 列间�?*/
  margin-top: 40px;
}

/* 文章主体样式 */
.blog-title {
  font-size: 2.5rem;
  margin-bottom: 15px;
  line-height: 1.2;
  font-weight: 700;
}

.author-info {
  display: flex;
  gap: 15px;
  font-size: 0.95rem;
  color: #666;
  margin-bottom: 20px;
}

.download-btn {
  padding: 20px;
  background-color: #025cd8;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  margin: 15px 0;
  font-size: 20px;
  display: inline-block;
}

.content-divider {
  border: 0;
  height: 1px;
  background-color: #eee;
  margin: 30px 0;
}

.article-content {
  line-height: 1.6;
  font-size: 1.05rem;
}

/* 相关文章样式 */
/* 优化后的相关文章样式 */
.related-post-item {
  display: flex;
  gap: 20px;
  padding: 15px 0;
  border-bottom: 1px solid #ccc;
  cursor: pointer;
}

.related-post-thumb {
  /* width: 100px; */
  height: 80px;
  object-fit: cover;
  border-radius: 4px;
  flex-shrink: 0;
}

.related-post-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.related-post-title {
  font-size: 1.1rem;
  margin-bottom: 8px;
  white-space: nowrap;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.related-post-desc {
  color: #666;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.related-post-divider {
  border: 0;
  border-top: 1px solid #eee;
  margin: 0;
}

.author {
  display: flex;
  /* padding: 40px; */
  max-width: 1000px;
  gap: 30px;
  margin: 30px auto;
  background: #f2fff6;
  border-radius: 12px;
  box-shadow: 0 2px 5px #ccc;
  /* align-items: center; */
}

.author-avatar {
  border-radius: 12px 0 0 12px;
  height: 100%;
}

.author-right-info {
  flex: 1;
  padding-right: 20px;

}

.author-olivia {
  padding: 20px 0;
}

/* 响应式调�?*/
@media (max-width: 992px) {
  .blog1-container {
    flex-direction: column;
    gap: 40px;
  }

  .author {
    flex-direction: column;
    padding: 10px;
    margin: 20px;
    gap: 0;
  }

  .main-content,
  .related-posts {
    flex: none;
    width: 100%;
  }
}
</style>